export class CostType {
  constructor(
    public id?: number,
    public name?: string,
  ) { }

  static adapt(item: any): CostType {
    return new CostType(
      item.id,
      item.name,
    );
  }

}
